module.exports = __webpack_public_path__ + "img/bg1.db224a2e.png";